import {getDateUtilDefaultInstance} from '/util/date.util';

export const handleNewLabel = ({item}: any) => {
  const dateUtil = getDateUtilDefaultInstance();
  const customerLastOrderedOnDate = new Date(item.lastOrderedOn);
  const getDateDiff = dateUtil.getDaysToToday(customerLastOrderedOnDate);
  return getDateDiff < 30;
};
